<div class="createdfolder">
    <div class="drive mainLink">
        <!-- [routerLinkActive]="['active']" -->
        <div class="folderName" (click)="showInbox()" [routerLink]="'/filemanager/inbox'" [routerLinkActive]="['active']" >
            <mat-icon class="type">inbox</mat-icon> Inbox
            <!-- <span class="ttl" *ngIf="totalInbox > 0">{{totalInbox}}</span> -->
        </div>

        <ng-container *ngIf="showLocalPanel"> 
          <div class="folderName" [routerLink]="'/filemanager/starred'" [routerLinkActive]="['active']" >
            <mat-icon class="type">star_rate</mat-icon> Starred
        </div>
        <div class="folderName" [routerLink]="'/filemanager/trash'" [routerLinkActive]="['active']" >
            <mat-icon class="type">restore_from_trash</mat-icon> Trash
        </div>
         </ng-container>


         <!-- <div class="sepreator"></div>       
        <div class="customDropDown"  [routerLink]="'/filemanager'" [ngClass]="{ 'active': reportsactive }">          
        
          <button mat-icon-button class="arrowIcon" (click)="showReportToggle()">
            <mat-icon *ngIf="showReports">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="!showReports">arrow_right</mat-icon>
          </button>
          
          <div class="folderName" (click)="getLeftMenuList()">
            <mat-icon class="type">list_alt</mat-icon>Reports
            <button mat-icon-button class="createNew" color="primary">            
            </button>
          </div>
        </div>


        <div class="allfolders" *ngIf="showReports">
         
          <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
         
            <mat-tree-node [ngClass]="{ 'active': activeNodeReport === node.subFolderID }" *matTreeNodeDef="let node ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
            
              <div class="folderRow">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden" >
                  arrow_drop_down
                </mat-icon>    
                <div class="folderName">
                  <mat-icon class="folder" (click)="getFileManagerFoldersdetailsReport(node)">view_list</mat-icon>
                  <span (click)="getFileManagerFoldersdetailsReport(node)">{{node.name}}</span>                  
  
                </div>
              </div>
              
            </mat-tree-node>
           
            <mat-tree-node [ngClass]="{ 'active': activeNodeReport === node.subFolderID }"  *matTreeNodeDef="let node;when: hasChild ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon id="node-{{node.name}}" (click)="rememberNode($event.currentTarget.id,$event)" class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon  class="folder" (click)="getFileManagerFoldersdetails(node)">view_list</mat-icon>
                
                 
                   <span  (click)="getFileManagerFoldersdetails(node)" class="flname">{{node.name}}</span>
                </div>
               
              </div>
              
            </mat-tree-node>
          </mat-tree>


          
        </div> -->

        <div class="sepreator"></div>
       
        <div class="customDropDown"  [routerLink]="'/filemanager'" [ngClass]="{ 'active': Formsactive }">          
        
          <button mat-icon-button class="arrowIcon" (click)="showFormsToggle()">
            <mat-icon *ngIf="showForms">arrow_drop_down</mat-icon>
            <mat-icon *ngIf="!showForms">arrow_right</mat-icon>
          </button>
          
          <div class="folderName" (click)="getLeftMenuList()">
            <mat-icon class="type">add_to_drive</mat-icon>My Drive
            <button mat-icon-button class="createNew" color="primary" (click)="openCreateNewFolder(createFileManagerFolder)">
              <mat-icon>create_new_folder</mat-icon>
            </button>
          </div>
        </div>

        <div class="allfolders" *ngIf="showForms">
         
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
         
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.fileManagerItemID }" *matTreeNodeDef="let node ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
            
              <div class="folderRow">
                <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility:hidden" >
                  arrow_drop_down
                </mat-icon>    
                <div class="folderName">
                  <mat-icon  *ngIf="node.isShared == false" class="folder" (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                  <mat-icon  *ngIf="node.isShared == true" class="folder" (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>
                  <span (click)="getFileManagerFoldersdetails(node)">{{node.name}}</span>
  
                  <mat-icon class="processed" matTooltip="{{node.aiAutomationTemplateName}}" *ngIf="node.isFile == false && node.aiAutomationTemplateID>0">assessment</mat-icon>

                  <div class="flOpt" >
                    <button mat-icon-button [matMenuTriggerFor]="menu" color="basic"><mat-icon>more_vert</mat-icon></button>
                    <mat-menu #menu="matMenu" xPosition="before">
                      <button mat-menu-item (click)="openCreateFolderDialogue(createFileManagerFolder,node)"><mat-icon>create_new_folder</mat-icon> Create Folder</button> 
                      <button mat-menu-item (click)="getFileManagerFoldersdetails(node)"><mat-icon>folder_open</mat-icon> Open</button>           
                      <ng-container *ngIf="node.name != 'My Projects'">
                        <button mat-menu-item (click)="renameFileManagerItem(node)"><mat-icon>format_size</mat-icon> Rename  </button>
                        <button mat-menu-item (click)="MoveTo(node)"><mat-icon>low_priority</mat-icon> Move to  </button>
                        <button mat-menu-item (click)="DeleteFolders(node)"><mat-icon>delete_outline</mat-icon> Delete</button>.
                      </ng-container>

                    </mat-menu>
                  </div>
  
                </div>
              </div>
              
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node [ngClass]="{ 'active': activeNode === node.fileManagerItemID }"  *matTreeNodeDef="let node;when: hasChild ; let indx = index"  matTreeNodePadding matTreeNodePaddingIndent="20">
              <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon id="node-{{node.name}}" (click)="rememberNode($event.currentTarget.id,$event)" class="mat-icon-rtl-mirror arrowIcon">
                  {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                </mat-icon>                
                <div class="folderName">
                  <mat-icon  *ngIf="node.isShared == false" class="folder" (click)="getFileManagerFoldersdetails(node)">folder</mat-icon>
                  <mat-icon  *ngIf="node.isShared == true" class="folder" (click)="getFileManagerFoldersdetails(node)">folder_shared</mat-icon>

                  <!-- <mat-icon class="folder" (click)="getFileManagerFoldersdetails(node)">folder</mat-icon> -->
                   <span  (click)="getFileManagerFoldersdetails(node)" class="flname">{{node.name}}</span>
                   <mat-icon class="processed" matTooltip="{{node.aiAutomationTemplateName}}" *ngIf="node.isFile == false && node.aiAutomationTemplateID>0">assessment</mat-icon>
                </div>
                <div class="flOpt">
                  <button mat-icon-button [matMenuTriggerFor]="menu" color="basic"><mat-icon>more_vert</mat-icon></button>
                  <mat-menu #menu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="openCreateFolderDialogue(createFileManagerFolder,node)"><mat-icon >create_new_folder</mat-icon> Create Folder</button> 
                    <button mat-menu-item (click)="getFileManagerFoldersdetails(node)"><mat-icon>folder_open</mat-icon> Open</button>     
                    <!-- <button mat-menu-item><mat-icon>format_size</mat-icon> Rename  </button> -->
                    <button mat-menu-item (click)="renameFileManagerItem(node)"><mat-icon>format_size</mat-icon> Rename  </button>
                    <!-- <button mat-menu-item><mat-icon>low_priority</mat-icon> Move to  </button> -->
                    <button mat-menu-item (click)="MoveTo(node)"><mat-icon>low_priority</mat-icon> Move to  </button>
                    <button mat-menu-item (click)="DeleteFolders(node)"><mat-icon>delete_outline</mat-icon> Delete</button>
                  </mat-menu>
                </div>
              </div>
              
            </mat-tree-node>
          </mat-tree>


          
        </div>

        <!-- (click)="getSharedWithMe()" [routerLink]="'/esignature/'"  [ngClass]="{ 'active': SharedWithMeactive }" -->

        <div class="folderName" (click)="getSharedWithMe()"  [routerLink]="'/filemanager/'"  [ngClass]="{ 'active': SharedWithMeactive }">
         
          <!-- <mat-icon class="type">portrait</mat-icon> Shared with me -->
          <mat-icon class="type">share</mat-icon> Shared with me
         
        </div>

    </div>
</div>


<ng-template #createFileManagerFolder>
  <form  [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
      Create Folder            
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>      
    </h2>   
    
  <mat-dialog-content class="mat-typography">
    <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput [required]="true"  placeholder="Add folder name" formControlName="filemanagerFolderName"/>
        <mat-error
        *ngIf="
          formDialog.get('filemanagerFolderName').invalid &&
          (formDialog.get('filemanagerFolderName').dirty ||
          formDialog.get('filemanagerFolderName').touched)">
        <span>This field is mandatory.</span>
      </mat-error>
      </mat-form-field>
  
  
  </mat-dialog-content>
  
  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="formDialog.invalid" 
    (click)="AddFolderName(formDialog.value)">Create</button>
  </mat-dialog-actions>
  
    </form>
</ng-template>